import request from "axios";
import { interceptError } from "../axiosInterceptors";
import { mapPostRequestParams } from "./services";

export const bacsDebitCheckout = async (params) => {
  return await request(
    "/stripe/bacs_debit_checkout",
    mapPostRequestParams(params.entity_id, params),
  )
    .then((response) => {
      return response;
    })
    .catch((error) => interceptError(error));
};

export const bacsDebitConfirmed = async (params) => {
  return await request(
    "/stripe/bacs_debit_confirmed",
    mapPostRequestParams(params.entity_id, params),
  )
    .then((response) => {
      return response;
    })
    .catch((error) => interceptError(error));
};
